import axiosAPI from "../utilities/axios";

export default {
  getOrder: async (id: any) => await axiosAPI.get(`/orders/${id}`),
};
